import { GOTO_UNIT } from '../../actions/routing/route.actions'

export default (state = '', action = {}) => (action.type === GOTO_UNIT ? action.payload.unitID : state)
